"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$PaymentMethodResponseDto = void 0;
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
exports.$PaymentMethodResponseDto = {
    properties: {
        id: {
            type: 'string',
        },
        billing_details: {
            type: 'PaymentMethodBillingDetails',
        },
        card: {
            type: 'PaymentMethodCard',
            isNullable: true,
        },
        created: {
            type: 'number',
        },
        customer: {
            type: 'one-of',
            contains: [{
                    type: 'string',
                }, {
                    type: 'StripeCustomer',
                }],
            isNullable: true,
        },
        customer_balance: {
            type: 'PaymentMethodCustomerBalance',
            isNullable: true,
        },
        livemode: {
            type: 'boolean',
        },
        metadata: {
            type: 'StripeMetadata',
            isNullable: true,
        },
        type: {
            type: 'PaymentMethodType',
        },
    },
};
